exports.locales = ['en']
exports.defaultLocale = 'en'
